<template>
    <div>
        <div class="tableSelect" ref="tableSelect">
            <el-form :inline="true" :model="formInline" label-position="left">
                <el-form-item label="销售名称：">
                    <el-input size="small" v-model.trim="formInline.name" maxlength="60" clearable 
                        placeholder="请输入销售名称" @change="search" style="width:120px"></el-input>
                </el-form-item>
                <el-form-item label=""><el-button @click="search" type="primary" icon="Search">查询</el-button></el-form-item>
                <el-form-item label=""><el-button @click="reset" icon="Refresh">重置</el-button></el-form-item>
                <el-form-item label=""><el-button @click="add" type="success" icon="Plus">新增</el-button></el-form-item>
                <el-form-item label=""><el-button @click="openTransferDialog" type="warning" icon="Switch">批量转移</el-button></el-form-item>
            </el-form>
        </div>
        <div class="table">
            <el-table :height="'calc('+(tableHeight)+'px)'" stripe :data="tableData" ref="tableref" 
                v-loading="loadingPage" style="width:100%">
                    <el-table-column type="index" width="70" align="center" label="序号">
                        <template #default="scope">
                            <span>{{ getIndex(scope.$index) }}</span>
                        </template>
                    </el-table-column>
                    
                    <el-table-column min-width="110" prop="name" label="销售名称"></el-table-column>
                    <el-table-column min-width="100" prop="email" label="邮箱"></el-table-column>
                    <el-table-column min-width="100" prop="phone" label="电话"></el-table-column>
                    <el-table-column min-width="100" prop="description" label="备注"></el-table-column>
                    <el-table-column min-width="150" prop="create_datetime" label="创建时间"></el-table-column>
                    
                    <el-table-column label="操作" align="center" fixed="right" width="180">
                        <template #default="scope">
                            <el-button size="small" link type="primary" @click="edit(scope.row)" icon="Edit"></el-button>
                            <el-button size="small" link type="warning" @click="openTransferDialogForSales(scope.row)" icon="Switch"></el-button>
                            <el-button size="small" link type="danger" @click="remove(scope.row.id)" icon="Delete"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
        </div>
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

        <!-- Edit Dialog -->
        <el-dialog 
            v-model="dialogVisible" 
            :close-on-click-modal="false" 
            :before-close="cancel"
            width="600px"
            class="edit-dialog">
            
            <template #header>
                <div class="dialog-header">
                    <h3 class="dialog-title">
                        <el-icon>{{ isEdit ? 'Edit' : 'Plus' }}</el-icon>
                        {{ loadingTitle }}
                    </h3>
                </div>
            </template>

            <div class="dialog-content">
                <el-form :inline="false" :model="formData" :rules="rules" ref="rulesForm" 
                    label-position="right" label-width="120px" class="edit-form">
                    <div class="form-section">
                        <el-form-item label="销售名称" prop="name">
                            <el-input v-model="formData.name" placeholder="请输入销售名称"></el-input>
                        </el-form-item>
                        
                        <el-form-item label="邮箱" prop="email">
                            <el-input v-model="formData.email" placeholder="请输入邮箱地址"></el-input>
                        </el-form-item>
                        
                        <el-form-item label="电话" prop="phone">
                            <el-input v-model="formData.phone" placeholder="请输入电话号码"></el-input>
                        </el-form-item>
                        
                        <el-form-item label="备注" prop="description">
                            <el-input v-model="formData.description" placeholder="请输入备注信息"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
            </div>

            <template #footer>
                <div class="dialog-footer">
                    <div class="footer-actions">
                        <el-button @click="cancel()" size="large">取消</el-button>
                        <el-button type="primary" @click="isEdit ? editSubmit(formData.id) : submitData()" size="large">
                            确定
                        </el-button>
                    </div>
                </div>
            </template>
        </el-dialog>

        <!-- Transfer Dialog -->
        <el-dialog 
            v-model="transferDialogVisible" 
            :close-on-click-modal="false" 
            :before-close="cancelTransfer"
            width="700px"
            class="transfer-dialog">
            
            <template #header>
                <div class="dialog-header">
                    <h3 class="dialog-title">
                        <el-icon><Switch /></el-icon>
                        批量转移销售关系
                    </h3>
                </div>
            </template>

            <div class="dialog-content">
                <div class="transfer-info">
                    <el-alert
                        title="转移说明"
                        type="info"
                        :closable="false"
                        show-icon>
                        <p>转移操作将把原销售名下的所有Agent和Linker关系转移给目标销售。</p>
                        <p>请谨慎操作，建议先预览转移详情。</p>
                    </el-alert>
                </div>

                <el-form :inline="false" :model="transferData" :rules="transferRules" ref="transferForm" 
                    label-position="right" label-width="120px" class="transfer-form">
                    
                    <div class="form-section">
                        <el-form-item label="原销售" prop="from_sales_id">
                            <el-select v-model="transferData.from_sales_id" placeholder="请选择要转移的销售" 
                                @change="onFromSalesChange" filterable class="full-width">
                                <el-option
                                    v-for="sales in tableData"
                                    :key="sales.id"
                                    :label="`${sales.name} (ID: ${sales.id})`"
                                    :value="sales.id">
                                    <span style="float: left">{{ sales.name }}</span>
                                    <span style="float: right; color: #8492a6; font-size: 13px">ID: {{ sales.id }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        
                        <el-form-item label="目标销售" prop="to_sales_id">
                            <el-select v-model="transferData.to_sales_id" placeholder="请选择接手的销售" filterable class="full-width">
                                <el-option
                                    v-for="sales in availableTargetSales"
                                    :key="sales.id"
                                    :label="`${sales.name} (ID: ${sales.id})`"
                                    :value="sales.id">
                                    <span style="float: left">{{ sales.name }}</span>
                                    <span style="float: right; color: #8492a6; font-size: 13px">ID: {{ sales.id }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="转移后处理">
                            <el-checkbox v-model="transferData.delete_old">转移完成后删除原销售记录</el-checkbox>
                        </el-form-item>
                    </div>

                                            <!-- Transfer Preview -->
                        <div v-if="transferPreview.show" class="transfer-preview">
                            <el-divider content-position="left">转移预览</el-divider>
                            
                            <!-- 统计信息 -->
                            <div class="preview-stats">
                                <div class="stat-item">
                                    <el-icon><Building /></el-icon>
                                    <span class="stat-label">Agent数量:</span>
                                    <el-tag type="success" size="large">{{ transferPreview.agents_count }}</el-tag>
                                </div>
                                <div class="stat-item">
                                    <el-icon><Link /></el-icon>
                                    <span class="stat-label">Linker数量:</span>
                                    <el-tag type="primary" size="large">{{ transferPreview.linkers_count }}</el-tag>
                                </div>
                                <div class="stat-item">
                                    <el-icon><Collection /></el-icon>
                                    <span class="stat-label">总记录数:</span>
                                    <el-tag type="info" size="large">{{ transferPreview.total_records }}</el-tag>
                                </div>
                            </div>

                            <!-- 转移信息 -->
                            <div class="transfer-info-row">
                                <div class="transfer-flow">
                                    <el-tag type="warning" size="large">{{ transferPreview.from_sales_name }}</el-tag>
                                    <el-icon class="arrow-icon"><Right /></el-icon>
                                    <el-tag type="success" size="large">{{ transferPreview.to_sales_name }}</el-tag>
                                </div>
                            </div>

                            <!-- 样例数据 -->
                            <div v-if="transferPreview.agents_count > 0 || transferPreview.linkers_count > 0" class="sample-data">
                                <!-- Agent 样例 -->
                                <div v-if="transferPreview.agent_samples && transferPreview.agent_samples.length > 0" class="sample-section">
                                    <h4 class="sample-title">
                                        <el-icon><Building /></el-icon>
                                        Agent 样例 (显示前5个)
                                    </h4>
                                    <div class="sample-list">
                                        <div v-for="agent in transferPreview.agent_samples" :key="`agent-${agent.id}`" class="sample-item">
                                            <span class="sample-name">{{ agent.company }}</span>
                                            <span class="sample-id">ID: {{ agent.agent_id }}</span>
                                        </div>
                                        <div v-if="transferPreview.agents_count > 5" class="more-items">
                                            ... 还有 {{ transferPreview.agents_count - 5 }} 个Agent
                                        </div>
                                    </div>
                                </div>

                                <!-- Linker 样例 -->
                                <div v-if="transferPreview.linker_samples && transferPreview.linker_samples.length > 0" class="sample-section">
                                    <h4 class="sample-title">
                                        <el-icon><Link /></el-icon>
                                        Linker 样例 (显示前5个)
                                    </h4>
                                    <div class="sample-list">
                                        <div v-for="linker in transferPreview.linker_samples" :key="`linker-${linker.id}`" class="sample-item">
                                            <span class="sample-name">{{ linker.company }}</span>
                                            <span class="sample-id">Link ID: {{ linker.link_id }}</span>
                                        </div>
                                        <div v-if="transferPreview.linkers_count > 5" class="more-items">
                                            ... 还有 {{ transferPreview.linkers_count - 5 }} 个Linker
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- 无数据提示 -->
                            <div v-if="transferPreview.agents_count === 0 && transferPreview.linkers_count === 0" class="no-data-notice">
                                <el-alert
                                    title="该销售没有关联的Agent和Linker数据"
                                    type="warning"
                                    :closable="false"
                                    show-icon>
                                    <p>如果选择"转移完成后删除原销售记录"，将直接删除该销售。</p>
                                </el-alert>
                            </div>
                        </div>
                </el-form>
            </div>

            <template #footer>
                <div class="dialog-footer">
                    <div class="footer-actions">
                        <el-button @click="cancelTransfer()" size="large">取消</el-button>
                        <el-button @click="previewTransfer" type="info" size="large" :loading="previewLoading">
                            预览转移
                        </el-button>
                        <el-button type="danger" @click="executeTransfer" size="large" :loading="transferLoading" 
                            :disabled="!transferPreview.show">
                            执行转移
                        </el-button>
                    </div>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
    import Pagination from "@/components/Pagination";
    import {getSalesList,newSales,deleterSales,editSales,transferSales,previewTransferSales} from '@/api/api'
    import {getTableHeight} from "@/utils/util";
    export default {
        components:{
            Pagination
        },
        name:'salesManage',
        data() {
            const checkEmail = (rule, value, callback) => {
                if (value) {
                    var reg = /^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+)$/
                    if (reg.test(value) === false) {
                        callback(new Error('邮箱格式错误'))
                    } else {
                        callback()
                    }
                } else {
                    callback()
                }
            }
            const checkPhone = (rule, value, callback) => {
                if (value) {
                    var reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
                    if (reg.test(value) === false) {
                        callback(new Error('电话格式错误'))
                    } else {
                        callback()
                    }
                } else {
                    callback()
                }
            }
            return {
                loadingPage:false,
                tableHeight:500,
                formInline:{
                    name:'',
                    page: 1,
                    limit: 20,
                },
                loadingTitle:'新增Sales',
                dialogVisible:false,
                formData:{
                    name:'',
                    email:'',
                    phone:'',
                    description:'',
                },
                isEdit:false,
                pageparm: {
                    page: 1,
                    limit: 20,
                    total: 0
                },
                tableData:[],
                payerList:[],
                salesList:[],
                // 转移相关数据
                transferDialogVisible: false,
                transferData: {
                    from_sales_id: '',
                    to_sales_id: '',
                    delete_old: false
                },
                transferPreview: {
                    show: false,
                    agents_count: 0,
                    linkers_count: 0,
                    from_sales_name: '',
                    to_sales_name: ''
                },
                previewLoading: false,
                transferLoading: false,
                rules: {
                    name: [
                        { required: true, message: '请输入销售名称', trigger: 'blur' }
                    ],
                    email: [
                        { required: true, message: '请输入邮箱地址', trigger: 'blur' }, // 限制必填
                        { required: true, trigger: 'blur', validator: checkEmail }
                    ],
                    phone:[
                        {trigger: 'blur', validator: checkPhone }
                    ]
                },
                transferRules: {
                    from_sales_id: [
                        { required: true, message: '请选择原销售', trigger: 'change' }
                    ],
                    to_sales_id: [
                        { required: true, message: '请选择目标销售', trigger: 'change' }
                    ]
                }
            }
        },

        computed: {
            // 可选的目标销售列表（排除选中的原销售）
            availableTargetSales() {
                return this.tableData.filter(sales => sales.id !== this.transferData.from_sales_id);
            }
        },

        methods:{
            //获取列表
            async getData() {
                this.loadingPage = true
                getSalesList(this.formInline).then(res => {
                     this.loadingPage = false
                     if(res.code ==2000) {
                         this.tableData = res.data.data
                         this.pageparm.page = res.data.page;
                         this.pageparm.limit = res.data.limit;
                         this.pageparm.total = res.data.total;
                     }
                 })
            },
            // 表格序列号
            getIndex($index) {
                // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
                return (this.pageparm.page-1)*this.pageparm.limit + $index +1
            },
            // 新增保存sales
            submitData(){
                this.$refs.rulesForm.validate((valid) => {
                    if (valid) {
                        newSales(this.formData).then(res=>{
                            if(res.code==2000){
                                this.$message.success(res.msg);
                                this.dialogVisible=false;
                                this.getData();
                            }else{
                                this.$message.error(JSON.stringify(res.msg));;
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            editSubmit(){
                this.$refs.rulesForm.validate((valid) => {
                    if (valid) {
                        editSales(this.formData).then(res=>{
                            if(res.code==2000){
                                this.$message.success(res.msg);
                                this.dialogVisible=false;
                                this.getData();
                            }else{
                                this.$message.error(JSON.stringify(res.msg));;
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            add(){
                this.cancel();
                this.dialogVisible=true;
                this.isEdit=false;
                this.loadingTitle="新增Sales"
            },
            // 编辑sales账号
            edit(obj){
                this.formData=JSON.parse(JSON.stringify(obj));
                this.dialogVisible=true;
                this.isEdit=true;
                this.loadingTitle="编辑Sales"
            },
            // 删除sales账号 
            remove(id){
                this.$confirm('确定删除吗？','提示',{
                    confirmButtonText:'确定',
                    cancelButtonText:'取消'
                }).then(()=>{
                    deleterSales({id:id}).then(res=>{
                        if(res.code==2000){
                            this.$message.success(res.msg);
                            this.dialogVisible=false;
                            this.getData();
                        }else{
                            this.$message.error(JSON.stringify(res.msg));;
                        }
                    })
                }).catch(err=>{})
            },
            cancel(){
                this.formData={
                    name:'',
                    email:'',
                    phone:'',
                    description:'',
                };
                this.isEdit=false;
                this.dialogVisible=false;
            },
            reset() {
                this.formInline = {
                    name:'',
                    page:1,
                    limit: 20
                }
                this.pageparm={
                    page: 1,
                    limit: 20,
                    total: 0
                }
                this.getData()
            },
            callFather(parm) {
                this.formInline.page = parm.page
                this.formInline.limit = parm.limit
                this.getData()
            },
            search() {
                this.formInline.page = 1
                this.formInline.limit = 20
                this.getData()
            },
            // 计算搜索栏的高度
            listenResize() {
				this.$nextTick(() => {
				    this.getTheTableHeight()
				})
			},
            getTheTableHeight(){
                let tabSelectHeight = this.$refs.tableSelect?this.$refs.tableSelect.offsetHeight:0
                tabSelectHeight = this.isFull?tabSelectHeight - 110:tabSelectHeight
                this.tableHeight =  getTableHeight(tabSelectHeight)
            },
            
            // === 转移功能相关方法 ===
            
            // 打开转移对话框
            openTransferDialog() {
                this.resetTransferData();
                this.transferDialogVisible = true;
            },
            
            // 为特定销售打开转移对话框
            openTransferDialogForSales(salesRow) {
                this.resetTransferData();
                this.transferData.from_sales_id = salesRow.id;
                this.transferDialogVisible = true;
            },
            
            // 重置转移数据
            resetTransferData() {
                this.transferData = {
                    from_sales_id: '',
                    to_sales_id: '',
                    delete_old: false
                };
                this.transferPreview = {
                    show: false,
                    agents_count: 0,
                    linkers_count: 0,
                    from_sales_name: '',
                    to_sales_name: ''
                };
            },
            
            // 原销售变化时清除预览
            onFromSalesChange() {
                this.transferData.to_sales_id = '';
                this.transferPreview.show = false;
            },
            
            // 预览转移
            async previewTransfer() {
                // 表单验证
                const valid = await this.$refs.transferForm.validate().catch(() => false);
                if (!valid) return;
                
                this.previewLoading = true;
                try {
                    // 调用API获取实际的转移预览数据
                    const response = await previewTransferSales({
                        from_sales_id: this.transferData.from_sales_id,
                        to_sales_id: this.transferData.to_sales_id
                    });
                    
                    if (response.code === 2000) {
                        // 注意：API返回的数据结构是 response.data.data，需要获取嵌套的data
                        const data = response.data.data || response.data;
                        this.transferPreview = {
                            show: true,
                            agents_count: data.agents_count,
                            linkers_count: data.linkers_count,
                            from_sales_name: data.from_sales_name,
                            to_sales_name: data.to_sales_name,
                            agent_samples: data.agent_samples || [],
                            linker_samples: data.linker_samples || [],
                            total_records: data.total_records
                        };
                        this.$message.success('预览加载成功');
                    } else {
                        this.$message.error(response.msg || '预览失败');
                    }
                } catch (error) {
                    this.$message.error('预览失败: ' + error.message);
                } finally {
                    this.previewLoading = false;
                }
            },
            
            // 执行转移
            async executeTransfer() {
                // 确认操作
                const confirmMsg = `确定要将 ${this.transferPreview.from_sales_name} 的销售关系转移给 ${this.transferPreview.to_sales_name} 吗？`;
                try {
                    await this.$confirm(confirmMsg, '转移确认', {
                        confirmButtonText: '确定转移',
                        cancelButtonText: '取消',
                        type: 'warning'
                    });
                } catch {
                    return; // 用户取消
                }
                
                this.transferLoading = true;
                try {
                    const response = await transferSales(this.transferData);
                    if (response.code === 2000) {
                        this.$message.success(response.msg);
                        this.transferDialogVisible = false;
                        // 刷新列表
                        this.getData();
                    } else {
                        this.$message.error(response.msg || '转移失败');
                    }
                } catch (error) {
                    this.$message.error('转移失败: ' + error.message);
                } finally {
                    this.transferLoading = false;
                }
            },
            
            // 取消转移
            cancelTransfer() {
                this.resetTransferData();
                this.transferDialogVisible = false;
            }
        },
        created() {
            this.getData();
        },
        mounted() {
            // 监听页面宽度变化搜索框的高度
            window.addEventListener('resize', this.listenResize);
            this.$nextTick(() => {
              this.getTheTableHeight()
            })
        },

        unmounted() {
             // 页面销毁，去掉监听事件
			window.removeEventListener("resize", this.listenResize);
        },
    }
</script>

<style lang="scss" scoped>
</style>
